module.exports = __webpack_public_path__ + "img/mikepaper3@2x.693c953c.jpg";